import { z } from 'zod';
import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { DescuentoReglaSchema, } from '@/data/dto/descuentoRegla';
function buildPayload(values) {
    const montoMin = values.montoMinimo ? Number(values.montoMinimo) : null;
    return {
        codigo: values.codigo.toUpperCase(),
        nombre: values.nombre,
        descripcion: values.descripcion || null,
        soloTiposClase: values.soloTiposClase.length ? values.soloTiposClase : null,
        soloMetodosPago: values.soloMetodosPago.length ? values.soloMetodosPago : null,
        montoMinimo: montoMin != null && Number.isFinite(montoMin) ? montoMin : null,
    };
}
export const descuentosReglasApi = {
    async listar(tipo, activo) {
        const res = await apiClient.get(ENDPOINTS.descuentos, {
            params: { tipo, activo },
        });
        return z.object({ items: z.array(DescuentoReglaSchema) }).parse(res.data).items;
    },
    async crear(values) {
        const valorNum = Number(values.valor);
        const payload = {
            ...buildPayload(values),
            tipo: values.tipo,
            pct: values.tipoValor === 'PCT' ? valorNum : null,
            montoFijo: values.tipoValor === 'MONTO_FIJO' ? valorNum : null,
            vigenteDesde: values.vigenteDesde || null,
            vigenteHasta: values.vigenteHasta || null,
        };
        const res = await apiClient.post(ENDPOINTS.descuentos, payload);
        return DescuentoReglaSchema.parse(res.data);
    },
    async editar(id, values) {
        const res = await apiClient.patch(`${ENDPOINTS.descuentos}/${id}`, buildPayload(values));
        return DescuentoReglaSchema.parse(res.data);
    },
    async desactivar(id) {
        await apiClient.delete(`${ENDPOINTS.descuentos}/${id}`);
    },
};
